<script lang="ts" setup>
import {ref} from "vue";
import {XCircleIcon} from "@heroicons/vue/24/outline";
import VPlanRequired from "@/scripts/components/app/common/VPlanRequired.vue";
import {PlanType} from "@/scripts/types/account";

export interface Props {
    modelValue: string;
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: '',
});

const isInputActive = props.modelValue.length > 0 ? ref(true) : ref(false)

const addPixel = () => {
    isInputActive.value = true
}

const removePixel = () => {
    emit('update:modelValue', '');
    isInputActive.value = false
}

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
}>();

const handleInput = (e: Event) => {
    const value = (e.target as HTMLInputElement).value;
    emit('update:modelValue', value);
};

const availableIn = ["business"] as PlanType[]

</script>

<template>
    <v-plan-required :plan="availableIn">
        <button v-if="!isInputActive" @click="addPixel" type="button"
                class="inline-flex items-center px-2.5 py-1.5 text-xs font-medium rounded text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            + добавить пиксель
        </button>
        <div v-if="isInputActive">
            <div>
                <div class="flex items-center">
                    <div class="flex justify-between mr-2">
                        <label for="pixel" class="block text-xs font-medium text-gray-700">Ссылка на пиксель (используйте %random% для случайной комбинации)</label>
                    </div>
                    <div @click="removePixel" class="cursor-pointer">
                        <XCircleIcon class="'text-purple-400 hover:text-purple-500 mr-4 flex-shrink-0 h-4 w-4"
                                     aria-hidden="true"/>
                    </div>
                </div>
                <div class="mt-1">
                    <input required type="url" name="pixel" id="pixel"
                           class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                           @input="handleInput"
                           v-model="modelValue"
                    />
                </div>
            </div>
        </div>
    </v-plan-required>
</template>